<button [attr.aria-label]="'Hilfetext anzeigen'"
        [attr.data-bs-target]="dataTarget"
        [attr.data-bs-toggle]="dataModal"
        [ngClass]="{'inline': inline, 'btn-help-smaller': smaller}"
        class="ba-round-icon-btn ba-icon-help"
        id="button-help-nachweis"
        data-analytics-track="true"
        data-analytics-category="Icon"
        data-analytics-action="Klick"
        [dataAnalyticsName]="dataAnalyticsName"
        data-analytics-value=""
        title="Info-Dialog zum Thema {{label}}"
        type="button">
</button>
